export const DEFAULT_GENE_GROUPING = 'l2Target';
